import React from 'react';
import { Routes, Route } from 'react-router-dom';
import PermissionRoute from './PermissionRoute';
import OfflineSalesOrderListPage from '../pages/offlineSales/OfflineSalesOrderListPage';
import OfflineSalesOrderDetailPage from '../pages/offlineSales/OfflineSalesOrderDetailPage';
import CustomerListPage from '../pages/offlineSales/CustomerListPage';
import CustomerImportPage from '../pages/offlineSales/CustomerImportPage';
import CashierSessionPage from '../pages/offlineSales/CashierSessionPage';
import OfflineSalesSettingsPage from '../pages/offlineSales/OfflineSalesSettingsPage';
import PaymentMethodsPage from '../pages/offlineSales/PaymentMethodsPage';
import ReceivablesPage from '../pages/offlineSales/ReceivablesPage';
import CustomerStatementPage from '../pages/offlineSales/CustomerStatementPage';
import CustomerPaymentsPage from '../pages/offlineSales/CustomerPaymentsPage';
import ReceiveCustomerPaymentPage from '../pages/offlineSales/ReceiveCustomerPaymentPage';
import CustomerPaymentDetailPage from '../pages/offlineSales/CustomerPaymentDetailPage';
import ChequesPage from '../pages/offlineSales/ChequesPage';
import CreateOfflineSalesOrderPage from '../pages/offlineSales/CreateOfflineSalesOrderPage';
import EditOfflineSalesOrderPage from '../pages/offlineSales/EditOfflineSalesOrderPage';
import QuotationListPage from '../pages/quotation/QuotationListPage';
import CreateQuotationPage from '../pages/quotation/CreateQuotationPage';
import QuotationDetailsPage from '../pages/quotation/QuotationDetailsPage';
import DeliveryNoteListPage from '../pages/deliveryNote/DeliveryNoteListPage';
import CreateDeliveryNotePage from '../pages/deliveryNote/CreateDeliveryNotePage';
import DeliveryNoteDetailsPage from '../pages/deliveryNote/DeliveryNoteDetailsPage';
import ReturnNoteListPage from '../pages/returnNote/ReturnNoteListPage';
import CreateReturnNotePage from '../pages/returnNote/CreateReturnNotePage';
import ReturnNoteDetailsPage from '../pages/returnNote/ReturnNoteDetailsPage';
import CreditNoteListPage from '../pages/creditNote/CreditNoteListPage';
import CreateCreditNotePage from '../pages/creditNote/CreateCreditNotePage';
import CreditNoteDetailsPage from '../pages/creditNote/CreditNoteDetailsPage';
import OfflineSalesPackingPage from '../pages/offlineSales/OfflineSalesPackingPage';
import OfflineCourierPackingBatchListPage from '../pages/offlineSales/OfflineCourierPackingBatchListPage';

const OfflineSalesRoutes = () => (
  <Routes>
    <Route
      path="orders"
      element={
        <PermissionRoute requiredPermission="view_offline_sales_orders">
          <OfflineSalesOrderListPage />
        </PermissionRoute>
      }
    />
    <Route
      path="orders/create"
      element={
        <PermissionRoute requiredPermission="create_offline_sales_order">
          <CreateOfflineSalesOrderPage />
        </PermissionRoute>
      }
    />
    <Route
      path="orders/:orderId"
      element={
        <PermissionRoute requiredPermission="view_offline_sales_orders">
          <OfflineSalesOrderDetailPage />
        </PermissionRoute>
      }
    />
    <Route
      path="orders/:orderId/edit"
      element={
        <PermissionRoute requiredPermission="edit_offline_sales_order">
          <EditOfflineSalesOrderPage />
        </PermissionRoute>
      }
    />

    <Route
      path="customers"
      element={
        <PermissionRoute requiredPermission="manage_offline_sales_customers">
          <CustomerListPage />
        </PermissionRoute>
      }
    />
    <Route
      path="customers/import"
      element={
        <PermissionRoute requiredPermission="manage_offline_sales_customers">
          <CustomerImportPage />
        </PermissionRoute>
      }
    />

    <Route
      path="sessions"
      element={
        <PermissionRoute requiredPermission="manage_offline_sales_sessions">
          <CashierSessionPage />
        </PermissionRoute>
      }
    />

    <Route
      path="settings"
      element={
        <PermissionRoute requiredPermission="manage_offline_sales_settings">
          <OfflineSalesSettingsPage />
        </PermissionRoute>
      }
    />

    <Route
      path="payment-methods"
      element={
        <PermissionRoute requiredPermission="manage_offline_sales_settings">
          <PaymentMethodsPage />
        </PermissionRoute>
      }
    />

    <Route
      path="receivables"
      element={
        <PermissionRoute requiredPermission="view_receivables">
          <ReceivablesPage />
        </PermissionRoute>
      }
    />
    <Route
      path="customer-payments"
      element={
        <PermissionRoute requiredPermission="view_receivables">
          <CustomerPaymentsPage />
        </PermissionRoute>
      }
    />
    <Route
      path="customer-payments/new"
      element={
        <PermissionRoute requiredPermission="edit_offline_sales_order">
          <ReceiveCustomerPaymentPage />
        </PermissionRoute>
      }
    />
    <Route
      path="customer-payments/:id"
      element={
        <PermissionRoute requiredPermission="view_receivables">
          <CustomerPaymentDetailPage />
        </PermissionRoute>
      }
    />
    <Route
      path="cheques"
      element={
        <PermissionRoute requiredPermission="view_receivables">
          <ChequesPage />
        </PermissionRoute>
      }
    />
    <Route
      path="customers/:customerId/statement"
      element={
        <PermissionRoute requiredPermission="view_receivables">
          <CustomerStatementPage />
        </PermissionRoute>
      }
    />
    <Route
      path="packing"
      element={
        <PermissionRoute requiredPermission="view_all_packing_batches">
          <OfflineCourierPackingBatchListPage />
        </PermissionRoute>
      }
    />
    <Route
      path="packing/create"
      element={
        <PermissionRoute requiredPermission="create_packing_batch">
          <OfflineSalesPackingPage />
        </PermissionRoute>
      }
    />

    <Route
      path="quotations"
      element={
        <PermissionRoute requiredPermission="create_quotation">
          <QuotationListPage />
        </PermissionRoute>
      }
    />
    <Route
      path="quotations/create"
      element={
        <PermissionRoute requiredPermission="create_quotation">
          <CreateQuotationPage />
        </PermissionRoute>
      }
    />
    <Route
      path="quotations/:quotationId"
      element={
        <PermissionRoute requiredPermission="create_quotation">
          <QuotationDetailsPage />
        </PermissionRoute>
      }
    />

    <Route
      path="delivery-notes"
      element={
        <PermissionRoute requiredPermission="create_delivery_note">
          <DeliveryNoteListPage />
        </PermissionRoute>
      }
    />
    <Route
      path="delivery-notes/create"
      element={
        <PermissionRoute requiredPermission="create_delivery_note">
          <CreateDeliveryNotePage />
        </PermissionRoute>
      }
    />
    <Route
      path="delivery-notes/:deliveryNoteId"
      element={
        <PermissionRoute requiredPermission="create_delivery_note">
          <DeliveryNoteDetailsPage />
        </PermissionRoute>
      }
    />

    <Route
      path="return-notes"
      element={
        <PermissionRoute requiredPermission="view_offline_sales_orders">
          <ReturnNoteListPage />
        </PermissionRoute>
      }
    />
    <Route
      path="return-notes/create"
      element={
        <PermissionRoute requiredPermission="create_return_note">
          <CreateReturnNotePage />
        </PermissionRoute>
      }
    />
    <Route
      path="return-notes/:returnNoteId"
      element={
        <PermissionRoute requiredPermission="view_offline_sales_orders">
          <ReturnNoteDetailsPage />
        </PermissionRoute>
      }
    />

    <Route
      path="credit-notes"
      element={
        <PermissionRoute requiredPermission="issue_credit_note">
          <CreditNoteListPage />
        </PermissionRoute>
      }
    />
    <Route
      path="credit-notes/create"
      element={
        <PermissionRoute requiredPermission="issue_credit_note">
          <CreateCreditNotePage />
        </PermissionRoute>
      }
    />
    <Route
      path="credit-notes/:creditNoteId"
      element={
        <PermissionRoute requiredPermission="issue_credit_note">
          <CreditNoteDetailsPage />
        </PermissionRoute>
      }
    />
  </Routes>
);

export default OfflineSalesRoutes;
